// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1CQSZ","errors":"Errors_errors__3wj9O"};